import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Grid2,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  Add,
  Delete,
  ExpandMore,
  Minimize,
  MoreVert,
  Refresh,
} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import AuthServices from "../../apis/AuthServices";
import { Controller, useForm } from "react-hook-form";
import Colors from "../../assets/styles";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";
import { useNavigate } from "react-router-dom";

// Mock data - replace with actual API calls

export default function TrainRoute() {
  // Form state

  const [stations, setStation] = useState([]);
  const [trains, setTrains] = useState([]);

  const [stationById, setStationById] = useState([]);
  const [routeTable, setRouteTable] = useState([]);
  const [checkbox, setCheckBox] = useState(false);

  const navigate = useNavigate()
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      dayCount: 0,
    },
  });
  const handleCheckboxChange = (event) => {
    setCheckBox(event.target.checked);
  };

  const handleChange = (event) => {
    getTrainById(event);
  };

  const getTrains = async () => {
    try {
      const result = await AuthServices.getTrains();
      if (result.IsSuccess == true) {
        setTrains(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  const getTrainById = async (id) => {
    try {
      const result = await AuthServices.getTrainsById(id);
      // console.log(result);
      if (result.IsSuccess == true) {
        setStationById(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  const handleDeleteItem = (index) => {
    const newRouteTable = routeTable.filter((_, i) => i !== index);
    setRouteTable(newRouteTable);
  };

  const getStations = async () => {
    try {
      const result = await AuthServices.getStations();
      // console.log(result);
      if (result.IsSuccess == true) {
        setStation(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const handleSave = async () => {
    const mapData = routeTable?.map((item) => ({
      DayCount: item.DayCount,
      arrivalTime: item?.orderNumber == 1 ? null : item?.arrivalTime,
      departureTime: item.departureTime,
      orderNumber: Number(item.orderNumber),
      trainId: item.trainId,
      stationDetailId: item.stationDetailId?.StationDetailsId,
      IsDayChanged: item?.IsDayChanged,
    }));

    try {
      const response = await AuthServices.addTrainRoute(mapData);
      if (response?.IsSuccess == true) {
        reset();
        SuccessToaster("Station Added Successfully");
        navigate("/dashboard")
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getTrains();
    getStations();
  }, []);

  const onSubmit = (formData) => {
    console.log(formData);

    const isDuplicate = routeTable.some(
      (item) =>
        item.stationDetailId?.StationDetailsId ==
          formData?.stationName?.StationDetailsId ||
        item.orderNumber == formData?.orderNo
    );

    if (isDuplicate) {
      ErrorToaster("This Station or Order Number already exists.");
      return;
    }

    const obj = {
      trainId: formData?.trainName,
      stationDetailId: formData?.stationName,
      arrivalTime: formData?.orderNo == 1 ? null : formData?.arrivalTime,
      departureTime: formData?.departureTime,
      orderNumber: formData?.orderNo,
      IsDayChanged: checkbox,
      DayCount: formData?.dayCount,
    };

    setRouteTable([...routeTable, obj]);
  };

  return (
    <Box sx={{ padding: "24px 0" }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",

          borderColor: "divider",
          mb: 1,
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          sx={{
            color: Colors.primary,
            fontWeight: 500,
            letterSpacing: "1px",
          }}
        >
          ADD ROUTE
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          TRAIN / ADD ROUTE
        </Typography>
      </Box>

      {/* Train Route Details Card */}
      <Card sx={{ mb: 3, borderRadius: "12px" }}>
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: 1,
            color: Colors.primary,

            borderColor: "divider",
          }}
        >
          <Typography variant="h6">ROUTE DETAILS</Typography>
        </Box>
        <CardContent>
          <Box component="form" onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
              {/* Train Selection */}
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                  Train Name
                </Typography>
                <Controller
                  name="trainName"
                  control={control}
                  rules={{ required: "Train Name is required" }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={trains}
                      getOptionLabel={(option) => option?.TrainName || ""}
                      isOptionEqualToValue={(option, value) =>
                        option?.TrainId === value
                      }
                      value={
                        trains?.find(
                          (train) => train.TrainId === field.value
                        ) || null
                      }
                      onChange={(_, value) => {
                        field.onChange(value?.TrainId || "");
                        handleChange(value?.TrainId || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={!!errors.trainName}
                          helperText={errors.trainName?.message}
                        />
                      )}
                    />
                  )}
                />
              </Grid>

              {/* Station Details */}
              <Grid item xs={12} md={12} sm={12}>
                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Station Name
                    </Typography>
                    <Controller
                      name="stationName"
                      control={control}
                      rules={{
                        required: "Station Name is required",
                        validate: (value) => {
                          // Check if the selected station already exists in the stations array
                          if (
                            stationById.some(
                              (station) =>
                                station.StationDetailsId ===
                                value?.StationDetailsId
                            )
                          ) {
                            return "This station already exists.";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          options={stations}
                          getOptionLabel={(option) => option?.StationName || ""}
                          isOptionEqualToValue={(option, value) =>
                            option?.StationDetailsId === value?.StationDetailsId
                          }
                          value={field.value || null}
                          onChange={(_, value) => field.onChange(value || null)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              error={!!errors.stationName}
                              helperText={errors.stationName?.message}
                            />
                          )}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Station Order Number
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      {...register("orderNo", {
                        required: "Station Order Number is required",

                        validate: (value) => {
                          if (
                            stationById.some(
                              (station) => station.OrderNumber === Number(value)
                            )
                          ) {
                            return "This Order Number already exists.";
                          }
                          return true;
                        },
                      })}
                      error={!!errors.orderNo}
                      helperText={errors.orderNo?.message || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Arrival Time
                    </Typography>
                    <TextField
                      fullWidth
                      type="time"
                      //   value={arrival}
                      //   onChange={(e) => setArrival(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      {...register("arrivalTime", {
                        required:
                          watch("orderNo") == 1
                            ? false
                            : "Arrival Time is required", // Disable validation if orderNo is 1
                      })}
                      disabled={watch("orderNo") == 1}
                      error={!!errors.arrivalTime}
                      helperText={
                        errors.arrivalTime ? errors.arrivalTime.message : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Departure Time
                    </Typography>
                    <TextField
                      fullWidth
                      type="time"
                      InputLabelProps={{ shrink: true }}
                      {...register("departureTime", {
                        required: "Departure Time is Required",
                      })}
                      error={!!errors.departureTime}
                      helperText={
                        errors.departureTime ? errors.departureTime.message : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Is Day Changed
                    </Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkbox}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setCheckBox(isChecked);
                            if (!isChecked) setValue("dayCount", 0); // Set to 0 if unchecked
                          }}
                        />
                      }
                      label="Is Day Changed"
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Day Count
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      {...register("dayCount", {
                        required: "Day Count Number is Required",
                        validate: (value) => {
                          if (checkbox && ![1, 2, 3].includes(Number(value))) {
                            return "Only 1, 2, or 3 are allowed";
                          }
                          return true;
                        },
                      })}
                      disabled={!checkbox}
                      error={!!errors.dayCount}
                      helperText={errors.dayCount?.message}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{ display: "flex", alignItems: "flex-end" }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        minWidth: "40px",
                        width: "40px",
                        height: "40px",
                        bgcolor: "#133e02",
                        "&:hover": {
                          bgcolor: "green.800",
                        },
                      }}
                    >
                      <AddIcon />
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>

      {/* Route Table Card */}
      <Card sx={{ borderRadius: "12px" }}>
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: 1,
            color: Colors.primary,

            borderColor: "divider",
          }}
        >
          <Typography variant="h6">ROUTE</Typography>
        </Box>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "#133e02" }}>
                  <TableCell sx={{ color: "white" }}>#</TableCell>
                  <TableCell sx={{ color: "white" }}>Station Name</TableCell>
                  <TableCell sx={{ color: "white" }}>Arrival Time</TableCell>
                  <TableCell sx={{ color: "white" }}>Departure Time</TableCell>
                  <TableCell sx={{ color: "white" }}>
                    Station Order number
                  </TableCell>
                  <TableCell sx={{ color: "white" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {routeTable.map((route, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{route.stationDetailId?.StationName}</TableCell>
                    <TableCell>
                      {route.arrivalTime ? route.arrivalTime : "Null"}
                    </TableCell>
                    <TableCell>{route.departureTime}</TableCell>
                    <TableCell>{route.orderNumber}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleDeleteItem(index)}>
                        <Delete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={routeTable.length === 0}
              sx={{ background: "#133e02" }}
            >
              Save
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
